import { isAdmin, isDealer } from '../../../../../services/AccountService'

// todo: если будет еще переиспользоваться переписать для каждой роли!
export const getMapHeadTitles = () => {
  if (isAdmin()) return adminTitles
  if (isDealer()) return dealerTitles
  else return adminTitles
}

const adminTitles = {
  isExpiredAssign: '',
  checkbox: '',
  status: 'Статус',
  financialSourceId: 'Оплата',
  dealer: 'Дилер',
  sender: 'Источник',
  id: 'Номер заявки',
  created: 'Дата создания',
  installationDate: 'Дата установки',
  name: 'ФИО',
  locality: 'Адрес',
  phone: 'Номер телефона',
}
const dealerTitles = {
  isExpiredAssign: '',
  checkbox: '',
  status: 'Статус',
  financialSourceId: 'Оплата',
  sender: 'Источник',
  id: 'Номер заявки',
  created: 'Дата создания',
  installationDate: 'Дата установки',
  name: 'ФИО',
  locality: 'Адрес',
  phone: 'Номер телефона',
}

export const sortedKeys = [
  'financialSourceId',
  'id',
  'created',
  'installationDate',
  'name',
  'locality',
]

export const widthMap: Record<string, string> = {
  isExpiredAssign: '2%',
  checkbox: '4%',
  status: '5%',
  financialSourceId: '8%',
  dealer: '10%',
  sender: '10%',
  id: '8%',
  created: '8%',
  installationDate: '8%',
  name: '20%',
  locality: '20%',
  phone: '10%',
}

export const emptyTableHeadKeys = ['isExpiredAssign']
